<div class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header"> Sélectionner votre patient </div>
    <div class="modal-body">
      <!-- http://hypermed-test-fsv.juxta.cloud/Pages/EspacePatient/Patient/Fsv_LectureCarte.aspx?dateref=20220103&numNatPs=997002379044&numFiness=001047901&DRCAdr=localhost&DRCPort=1234&URLRetour=http://localhost:4200 -->
      <div class="search-bar">
        <input id="search-input" *ngIf="inputSearchForm" [formGroup]="inputSearchForm" [formControl]="inputSearchForm.get('searchInput')"
          placeholder="Rechercher un patient" type="text">
      </div>

      <div class="event-patient-content">
        <div class="searching-loader" [ngClass]="{ 'loading': isSearching }">
          <div class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <div class="no-result" [ngClass]="{ 'visible': searchingMessage }">
          Aucun patient trouvé
        </div>

        <div *ngIf="patientSearchList.length > 0" class="patient-find-list">
          <div class="patient-item" *ngFor="let patient of patientSearchList" (click)="selectPatient(patient.id)">
            <div class="patient-item-name">{{ patient.nomNaissance}}  {{patient.prenomNaissance }}</div>
            <div class="patient-item-status" *ngIf="patient.statutIdentite?.libelleStatus">{{ patient.statutIdentite.libelleStatus }}</div>
            <div class="patient-item-birth">({{ patient.dateNaissance }})</div>
          </div>
        </div>

        <div *ngIf="selectedPatient" class="patient-infos">
          <div class="patient-visuel-container">
            <div class="patient-visuel">
              {{selectedPatient.nom.slice(0,1)}}{{selectedPatient.prenom.slice(0,1)}}
            </div>
          </div>
          <div class="patient-name">{{ selectedPatient.nom }} {{selectedPatient.prenom}}
          </div>
          <div class="patient-birth">{{ selectedPatient.dateNaissance | date:"dd/MM/yyyy" }}</div>

          <div class="patient-contact-display" *ngFor="let patientAddress of selectedPatient.adresses">
            <ng-container *ngIf="patientAddress.isPrincipale === true">
              <div class="patient-no-edit-line">
                Téléphone : <span>{{ patientAddress.telephone ? patientAddress.telephone : '--' }}</span>
              </div>
              <div class="patient-no-edit-line">
                Mobile : <span>{{ selectedPatient.numeroMobile ? selectedPatient.numeroMobile : '--' }}</span>
              </div>
              <div class="patient-no-edit-line">
                Adresse : <span>{{ patientAddress.adresse ? patientAddress.adresse : '--' }}</span>
              </div>
              <div class="patient-no-edit-line">
                Code postal : <span>{{ patientAddress.codePostal ? patientAddress.codePostal : '--' }}</span>
              </div>
              <div class="patient-no-edit-line">
                Ville : <span>{{ patientAddress.ville ? patientAddress.ville : '--' }}</span>
              </div>
              <div class="patient-no-edit-line">
                Mail : <span>{{ patientAddress.email ? patientAddress.email : '--' }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="buttons-wrapper">
        <frg-button (activated)="closeSearchPatients()" [backgroundColor]="'var(--darkest-primary)'">Retour
        </frg-button>
        <frg-button *ngIf="selectedPatient" (activated)="closeSearchPatients(selectedPatient.id)">Sélectionner
        </frg-button>
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>
